<template>
  <div>
    <el-dialog
top="5vh"
      title="指定学管师"
      :visible.sync="dialogFormVisible"
      @close="emitClose"
      :close-on-click-modal="false"
      width="620px"
    >
      <el-form
        :model="dataForm"
        label-position="left"
        ref="formRules"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <el-form-item
          label="学管师："
          prop="learn_manager"
        >
          <el-select
            v-model="dataForm.learn_manager"
            placeholder="请选择学管师"
            clearable
          >
            <!-- <el-option
              v-for="(item,index) in $store.state.staffOptions"
              :key="index"
              :label="item.nickname"
              :value="item.id"
            ></el-option> -->
            <el-option v-for="item in $store.state.staffOptions.filter(v => {
              return v.depts.findIndex(t => {
                return t.id == 4 && v.status == 1
              }) != -1
            })" :key="item.id" :label="item.nickname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="emitClose(false)">取消</el-button>
        <el-button
          type="primary"
          @click="submit('formRules')"
        >确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>



import {
  editstudentlist,
} from "@/request/api";
export default {
  components: {
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    ids: {
      type: Array,
      default: () => [],
    },

  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
      },
      rules: {
        learn_manager: [{ required: true, message: "请选择学管师", trigger: "blur" }],
      },
    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.$store.dispatch('getStaffOptions')
      }
    },
  },
  methods: {

    emitClose() {
      this.$emit("close");
    },


    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            rows: this.ids.map(v => {
              return {
                id: v.id,
                learn_manager: this.dataForm.learn_manager
              }
            })
          }
          editstudentlist(query).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('修改成功')
              this.emitClose()
              this.$emit('submit')
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>